import { Image } from '@chakra-ui/image';
import { Box, Flex } from '@chakra-ui/layout';
import { useTheme } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { useCurrentColors } from '../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
function Version({ t }: { t: any }) {
    const currentColors = useCurrentColors();
    const theme = useTheme();
    return (
        <Flex
            position="relative"
            width="100%"
            minHeight="100vh"
            align="center"
            direction="column"
            backgroundImage={`url('${theme?.images?.loginBg}')`}
            backgroundPosition="center"
            backgroundSize="cover"
            backgroundRepeat="no-repeat">
            <Flex
                maxWidth={['318px', '384px', '470px', '470px', '470px']}
                width="100%"
                direction="column"
                boxShadow={`1px 2px 6px ${currentColors.boxShadow}`}
                backgroundColor={`${currentColors.componentBg}`}
                border={`1px solid ${currentColors.componentBorder}`}
                borderRadius="6px"
                align="center"
                m="0"
                mt="100px"
                mb="20px"
                px="25px"
                py="30px">
                <Image
                    src={theme?.images?.headerLogo}
                    maxWidth="100%"
                    width="auto"
                    height={'30px'}
                />
                <Box
                    marginTop="20px"
                    fontSize="18px">
                    {t('version')}
                </Box>
                <Box
                    mt="5px"
                    fontSize="14px">
                    common-{process.env.REACT_APP_VERSION}
                </Box>
            </Flex>
        </Flex>
    );
}

Version.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(Version);
